import sharedModule from '../../shared.module';

class AccountProvider {
    constructor(
        $q,
        $sessionStorage,
        accountApiService,
        authenticationService,
        userApiService
    ) {
        this.$q = $q;
        this.$sessionStorage = $sessionStorage;
        this.accountApiService = accountApiService;
        this.authenticationService = authenticationService;
        this.userApiService = userApiService;

        this.cache = {};
        this.promiseCache = {};
    }

    getAccountGuid() {
        if (this.$sessionStorage.accountGuid) {
            return this.$q.resolve(this.$sessionStorage.accountGuid);
        }

        var promiseId = 'getAccountGuid';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.authenticationService
            .verifyToken()
            .then(data => {
                if (data.Account) {
                    deferred.resolve(data.Account.Guid);
                    return;
                }

                deferred.reject(data);
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }

    getUserGuid() {
        if (this.$sessionStorage.userGuid) {
            return this.$q.resolve(this.$sessionStorage.userGuid);
        }

        var promiseId = 'getUserGuid';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.authenticationService
            .verifyToken()
            .then(data => {
                if (data.User) {
                    deferred.resolve(data.User.Guid);
                    return;
                }

                deferred.reject(data);
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }

    getAccountInfo() {
        if (this.cache.accountInfo) {
            return this.$q.resolve(this.cache.accountInfo);
        }

        var promiseId = 'getAccountInfo';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.authenticationService
            .getToken()
            .then(cloudToken => {
                this.getAccountGuid().then(accountGuid => {
                    this.accountApiService
                        .getAccountInfo(cloudToken, accountGuid)
                        .then(data => {
                            this.cache.accountInfo = data;
                            deferred.resolve(data);
                        }, deferred.reject);
                }, deferred.reject);
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }

    getAccountPlan() {
        if (this.cache.accountPlan) {
            return this.$q.resolve(this.cache.accountPlan);
        }

        var promiseId = 'getAccountPlan';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.getAccountGuid()
            .then(accountGuid => {
                this.accountApiService
                    .getPlanInformation(accountGuid)
                    .then(data => {
                        this.cache.accountPlan = data;
                        deferred.resolve(data);
                    }, deferred.reject);
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }

    getAccountUserInfo() {
        if (this.cache.accountUserInfo) {
            return this.$q.resolve(this.cache.accountUserInfo);
        }

        var promiseId = 'getAccountUserInfo';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.getAccountGuid()
            .then(accountGuid => {
                this.accountApiService.getBillingInformation(accountGuid).then(
                    billingInfo => {
                        this.cache.accountUserInfo = {
                            aan: billingInfo.aan,
                            username: billingInfo.email
                        };
                        deferred.resolve(this.cache.accountUserInfo);
                    },
                    billingInfo => deferred.reject(billingInfo)
                );
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }

    isAccountOwner() {
        var promiseId = 'isAccountOwner';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.getAccountInfo()
            .then(accountInfo => {
                if (!accountInfo || !accountInfo.OwnerGuid) {
                    deferred.resolve(false);
                    return;
                }

                this.getUserGuid().then(userGuid => {
                    deferred.resolve(accountInfo.OwnerGuid == userGuid);
                }, deferred.reject);
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }

    getUser() {
        if (this.cache.user) {
            return this.$q.resolve(this.cache.user);
        }

        let promiseId = 'getUser';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.getUserGuid()
            .then(userGuid => {
                if (userGuid) {
                    this.userApiService
                        .getUserByUserGuid(userGuid)
                        .then(user => {
                            deferred.resolve(user);
                        }, deferred.reject);

                    return;
                }

                deferred.reject();
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }
}

export default sharedModule.service('accountProvider', AccountProvider);



// WEBPACK FOOTER //
// ./modules/shared/services/account/accountProvider.service.js